import { Link } from "react-router-dom";

const NotFoundPage = () => {
    return (
        <div style={{ textAlign: "center", backgroundColor: "transparent", color:"white",padding: "2.5rem", position: "absolute", right: 0, left: 0 }}>
            <h1 style={{color:"white", fontSize:"3rem"}}>Oops! You seem to be lost.</h1>
            <p style={{ textAlign: "left"}}>Let me help redirect you to the right path:</p>

            <ul style={{ textAlign: "left", color:"white"}}>
                <li><Link to='/'>My Website Portofolio</Link> </li>
                <li><Link to='/video'>My Video Portofolio</Link></li>
            </ul>
        </div>
    );
}

export default NotFoundPage;